<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="m20.0288462 20c.5448717 0 1.0096153-.1996008 1.3942307-.5988024s.5769231-.8702595.5769231-1.4131736v-11.97604795c0-.54291417-.1923077-1.01397206-.5769231-1.41317365-.3846154-.3992016-.849359-.5988024-1.3942307-.5988024h-16.05769235c-.5448718 0-1.00961539.1996008-1.39423077.5988024-.38461539.39920159-.57692308.87025948-.57692308 1.41317365v11.97604795c0 .5429141.19230769 1.013972.57692308 1.4131736.38461538.3992016.84935897.5988024 1.39423077.5988024zm-8.0288462-8-8-4.26804124v-1.73195876l8 4.3092784 8-4.3092784v.9154354.81652336z"
        />
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'EmailSVG',
    props: {
        size: VueTypes.number.isRequired,
        color: VueTypes.string.isRequired,
    },
};
</script>

<style></style>
